import "@hotwired/turbo";
import "../controllers";
import TurboPower from "turbo_power";

import "@mapbox/search-js-web";
import "chartkick/chart.js";
import ahoy from "ahoy.js";

import Alpine from "alpinejs";
import persist from "@alpinejs/persist";
import mask from "@alpinejs/mask";
import * as ActiveStorage from "@rails/activestorage";

// Lexxy handles Action Text editing and direct uploads.
import "@37signals/lexxy";

import { carryLayoutHtmlClasses } from "../lib/layout_html_classes";

// Configure AlpineJS - https://alpinejs.dev/
window.Alpine = Alpine;
Alpine.plugin(persist);
Alpine.plugin(mask);
Alpine.start();
ActiveStorage.start();

TurboPower.initialize(Turbo.StreamActions);

// Reading the analytics dashboards is not product usage. Without this an
// admin reviewing traffic books pageviews against the very numbers they are
// reading — /admin/analytics dominates Top Pages, and every session timeline
// ends in a run of dashboard visits.
const ANALYTICS_SURFACE = /^\/admin\/analytics(\/|$)/;

carryLayoutHtmlClasses();

// Pageviews for every Turbo Drive navigation. Path only — query strings
// can carry search terms (PHI risk). Kiosk layouts are shared devices:
// tracking there books everything to whichever staff member signed in.
document.addEventListener("turbo:load", () => {
  if (document.documentElement.hasAttribute("data-kiosk-theme")) return;

  const page = window.location.pathname;
  if (ANALYTICS_SURFACE.test(page)) return;

  ahoy.track("$view", { page });
});

Turbo.StreamActions.frame_navigate = function() {
  const url = this.getAttribute("url");
  this.targetElements.forEach((element) => {
    if (element.matches("turbo-frame")) {
      element.removeAttribute("src");
      element.src = url;
    }
  });
};

Turbo.StreamActions.redirect = function() {
  window.location.href = this.getAttribute("url") || "/";
};
